/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.body.addEventListener("click", function(e) {
  const btn = e.target.closest("#btn-whatsapp");
  if (!btn) return;

  e.preventDefault();


});
// =========================
// RESUMO DO PEDIDO + FRETE
// =========================
document.addEventListener("DOMContentLoaded", function () {

  const container = document.getElementById('resumo-itens');
  const totalEl = document.getElementById('resumo-total');
  const freteEl = document.getElementById('resumo-frete');

  if (!container || !totalEl || !freteEl) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      let total = 0;
      container.innerHTML = "";

      cart.items.forEach(item => {

        const subtotal = item.quantity * item.price;
        total += subtotal;

        const div = document.createElement('div');
        div.classList.add('resumo-item');

        div.innerHTML = `
          <div class="resumo-left">
            <img src="${item.image}" class="resumo-img" />
            <div class="resumo-info">
              <strong>${item.product_title}</strong>
              <span>Qtd: ${item.quantity}</span>
            </div>
          </div>

          <div class="resumo-price">
            R$ ${(subtotal / 100).toFixed(2)}
          </div>
        `;

        container.appendChild(div);
      });

      const totalReais = total / 100;

      totalEl.innerText = `R$ ${totalReais.toFixed(2)}`;

      if (totalReais >= 300) {
        freteEl.innerHTML = `
          <span>Frete</span>
          <strong class="frete-gratis">Grátis</strong>
        `;
      } else {
        const falta = 300 - totalReais;
        freteEl.innerHTML = `
          <span>Frete</span>
          <span class="frete-aviso">
            Faltam R$ ${falta.toFixed(2)} para frete grátis
          </span>
        `;
      }

    });

});


// =========================
// BOTÃO WHATSAPP
// =========================
document.addEventListener("click", function (e) {

  const btn = e.target.closest("#btn-whatsapp");
  if (!btn) return;

  e.preventDefault();

  let message = "Solicitação de pedido\n\n";

  // ===== ITENS =====
  message += "Itens:\n";

  document.querySelectorAll("#resumo-itens > div").forEach(item => {

    const nome = item.querySelector("strong")?.innerText || "";
    const qtd = item.innerText.match(/Qtd:\s*(\d+)/)?.[1] || "";
    const preco = item.innerText.match(/R\$[\s\d,\.]+/)?.[0] || "";

    if (!nome) return;

    message += `${qtd}x ${nome} - ${preco}\n`;

  });

  // ===== TOTAL =====
  const total = document.querySelector("#resumo-total")?.innerText || "";
  if (total) {
    message += `\nTotal: ${total}\n`;
  }

  // ===== FRETE =====
  const frete = document.querySelector("#resumo-frete")?.innerText || "";
  if (frete) {
    message += `Frete: ${frete}\n`;
  }

  // ===== FORMULÁRIO =====
  const get = (name) =>
    document.querySelector(`[name="${name}"]`)?.value || "";

  message += "\nDados para entrega:\n";
  message += `Empresa: ${get("attributes[Empresa]")}\n`;
  message += `CNPJ: ${get("attributes[CNPJ]")}\n`;
  message += `Telefone: ${get("attributes[Telefone]")}\n`;

  message += "\nEndereço:\n";

  const rua = get("attributes[Rua]");
  const numero = get("attributes[Número]");
  const bairro = get("attributes[Bairro]");
  const cidade = get("attributes[Cidade]");
  const cep = get("attributes[CEP]");

  message += `${rua}, ${numero}\n`;
  message += `${bairro} - ${cidade}\n`;
  message += `CEP: ${cep}\n`;

  // ===== WHATSAPP =====
  const phone = "5551991339926";

  window.open(
    `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
    "_blank"
  );

});